<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="dark" class="app-navbar shadow-sm">
      <b-container>
        <b-navbar-brand href="/" class="app-navbar-brand">
          <img src="/android-chrome-192x192.png" alt="" class="app-navbar-logo" />
          GUC Voile
        </b-navbar-brand>

        <b-navbar-toggle target="main-header-collapse"></b-navbar-toggle>

        <b-collapse id="main-header-collapse" is-nav>
          <b-navbar-nav class="ml-auto align-items-lg-center">
            <b-nav-item to="/" class="home-nav-item mr-lg-2">
              <b-icon icon="house-door-fill" class="mr-1"></b-icon>
              Accueil
            </b-nav-item>

            <template v-if="!currentUser">
              <b-nav-item href="#" @click.prevent="showLoginModal = true">
                Connexion
              </b-nav-item>
            </template>

            <template v-else>
              <b-nav-item-dropdown
                right
                class="d-none d-lg-block user-dropdown"
                menu-class="user-dropdown-menu"
                toggle-class="user-dropdown-toggle"
              >
                <template #button-content>
                  <span class="d-flex align-items-center">
                    <span class="mr-2" aria-hidden="true">
                      <b-icon icon="person-fill"></b-icon>
                    </span>
                    <span class="font-weight-bold">{{ currentUser.name }}</span>
                  </span>
                </template>

                <b-dropdown-item-button class="d-flex align-items-center" @click.prevent="goToProfile">
                  <b-icon icon="person-fill" class="text-primary mr-2"></b-icon>
                  Voir mon profil
                </b-dropdown-item-button>
                <b-dropdown-item-button class="d-flex align-items-center" @click.prevent="goToMyRegistrations">
                  <b-icon icon="list-ul" class="text-success mr-2"></b-icon>
                  Mes inscriptions
                </b-dropdown-item-button>
                <b-dropdown-item-button class="d-flex align-items-center" @click.prevent="goToMyCovoits">
                  <b-icon icon="car-front" class="text-info mr-2"></b-icon>
                  Covoiturage
                </b-dropdown-item-button>
                <b-dropdown-item-button
                  v-if="canManageOpenings"
                  class="d-flex align-items-center"
                  @click.prevent="goToMyOpenings"
                >
                  <b-icon icon="calendar3" class="text-info mr-2"></b-icon>
                  Permanences
                </b-dropdown-item-button>
                <b-dropdown-item-button class="d-flex align-items-center" @click.prevent="goToAdhesions">
                  <b-icon icon="credit-card" class="text-warning mr-2"></b-icon>
                  Adhésion
                </b-dropdown-item-button>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item-button class="d-flex align-items-center text-danger" @click.prevent="logout">
                  <b-icon icon="box-arrow-right" class="mr-2"></b-icon>
                  Se déconnecter
                </b-dropdown-item-button>
              </b-nav-item-dropdown>

              <div class="d-lg-none w-100 mobile-user-section">
                <button
                  class="btn btn-link text-white d-flex justify-content-between align-items-center w-100 px-0 mt-2 user-mobile-toggle"
                  @click.prevent="toggleMobileUserMenu"
                >
                  <span>
                    <span class="mr-2" aria-hidden="true"><b-icon icon="person-fill"></b-icon></span>
                    <span class="font-weight-bold">{{ currentUser.name }}</span>
                  </span>
                  <b-icon :icon="mobileUserMenuOpen ? 'dash-circle' : 'plus-circle'" class="text-white"></b-icon>
                </button>

                <div v-if="mobileUserMenuOpen" class="mobile-user-menu">
                  <button class="dropdown-item d-flex align-items-center" @click.prevent="goToProfile">
                    <b-icon icon="person-fill" class="mr-2"></b-icon>
                    Voir mon profil
                  </button>
                  <button class="dropdown-item d-flex align-items-center" @click.prevent="goToMyRegistrations">
                    <b-icon icon="list-ul" class="text-success mr-2"></b-icon>
                    Mes inscriptions
                  </button>
                  <button class="dropdown-item d-flex align-items-center" @click.prevent="goToMyCovoits">
                    <b-icon icon="car-front" class="text-info mr-2"></b-icon>
                    Covoiturage
                  </button>
                  <button
                    v-if="canManageOpenings"
                    class="dropdown-item d-flex align-items-center"
                    @click.prevent="goToMyOpenings"
                  >
                    <b-icon icon="calendar3" class="text-info mr-2"></b-icon>
                    Permanences
                  </button>
                  <button class="dropdown-item d-flex align-items-center" @click.prevent="goToAdhesions">
                    <b-icon icon="credit-card" class="text-warning mr-2"></b-icon>
                    Adhésion
                  </button>
                  <div class="dropdown-divider"></div>
                  <button class="dropdown-item text-danger d-flex align-items-center" @click.prevent="logout">
                    <b-icon icon="box-arrow-right" class="mr-2"></b-icon>
                    Se déconnecter
                  </button>
                </div>
              </div>
            </template>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>

    <!-- MODAL LOGIN -->
    <LoginModal
      :visible.sync="showLoginModal"
      @logged-in="handleLoginSuccess"
    />
  </div>
</template>

<script>
import LoginModal from "@/components/LoginModal.vue";

import session from "@/store/session";
import UserService from "@/services/user.service";

export default {
  components: {
    LoginModal
  },
  data() {
    return {
      showLoginModal: false,
      currentUser: null,
      mobileUserMenuOpen: true
    };
  },
  async created() {
    await this.checkSession();
    this.handleRequiredLoginQuery();
  },
  computed: {
    canManageOpenings() {
      return (
        this.currentUser &&
        ['ouvreur', 'admin'].includes(this.currentUser.role)
      );
    }
  },
  watch: {
    $route() {
      this.mobileUserMenuOpen = true;
      this.handleRequiredLoginQuery();
    }
  },
  methods: {
    async checkSession() {
      try {
        const res = await UserService.refreshSession();
        this.currentUser = res.user;
        session.setUser(res.user);
      } catch (err) {
        this.currentUser = null;
        session.clear();
        console.error("Erreur session :", err);
      }
    },
    handleRequiredLoginQuery() {
      if (this.$route.query.login !== "required") return;

      if (!session.isLoggedIn()) {
        this.showLoginModal = true;
        return;
      }

      this.$router.replace({ query: null });
    },

    handleLoginSuccess(user) {
      console.log("Utilisateur connecté :", user);
      this.currentUser = user;
      session.setUser(user);
      this.mobileUserMenuOpen = true;
      if (this.$route.query.login === "required") {
        this.$router.replace({ query: null });
      } else {
        this.$router.go(0);
      }
    },

    goToProfile() {
      this.closeMobileUserMenu();
      this.$router.push({ name: "profile" });
    },

    goToMyOpenings() {
      this.closeMobileUserMenu();
      this.$router.push("/mes-ouvertures");
    },
    goToMyRegistrations() {
      this.closeMobileUserMenu();
      this.$router.push("/mes-inscriptions");
    },
    goToMyCovoits() {
      this.closeMobileUserMenu();
      this.$router.push("/mes-covoiturages");
    },
    goToAdhesions() {
      this.closeMobileUserMenu();
      this.$router.push("/adhesion");
    },
    toggleMobileUserMenu() {
      this.mobileUserMenuOpen = !this.mobileUserMenuOpen;
    },

    closeMobileUserMenu() {
      this.mobileUserMenuOpen = false;
    },

    async logout() {
      this.closeMobileUserMenu();
      try {
        await UserService.logout();
      } catch (error) {
        console.error("Erreur lors de la déconnexion :", error);
        return;
      }

      try {
        await UserService.refreshSession();
        this.currentUser = session.user;
        console.error("Déconnexion incomplète : la session serveur est encore active.");
      } catch {
        this.currentUser = null;
        session.clear();
        console.log("Utilisateur déconnecté");
      }
    }
  }
};
</script>

<style scoped>
.app-navbar {
  background: var(--gradient-header);
  min-height: 64px;
}

.app-navbar-brand {
  font-weight: 700;
  letter-spacing: 0.04em;
  font-size: 1.15rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.app-navbar-logo {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  object-fit: contain;
}

.home-nav-item :deep(.nav-link) {
  color: var(--color-text-on-dark) !important;
  border-radius: 999px;
  padding: 0.45rem 0.8rem;
  transition: background-color 0.15s ease;
}

.home-nav-item :deep(.nav-link:hover),
.home-nav-item :deep(.nav-link.router-link-exact-active) {
  background-color: var(--color-overlay-medium);
}

.user-dropdown :deep(.nav-link) {
  color: var(--color-text-on-dark) !important;
  padding: 0.5rem 0.75rem;
  border-radius: 999px;
  transition: background-color 0.15s ease;
}

.user-dropdown :deep(.nav-link:hover),
.user-dropdown :deep(.show > .nav-link) {
  background-color: var(--color-overlay-medium);
}

.user-dropdown :deep(.user-dropdown-toggle.dropdown-toggle::after) {
  display: none !important;
}

.user-dropdown-menu {
  min-width: 220px;
  margin-top: 0.5rem;
  border: 1px solid var(--color-dropdown-border);
  box-shadow: var(--shadow-dropdown);
  border-radius: 0.5rem;
  padding: 0.35rem 0;
}

.user-dropdown-menu .dropdown-item {
  color: inherit;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.user-dropdown-menu .dropdown-item.text-danger {
  color: var(--color-danger) !important;
}

.user-mobile-toggle {
  text-decoration: none !important;
}

.user-mobile-toggle:focus {
  box-shadow: none;
}

.mobile-user-menu {
  background: var(--color-overlay-soft);
  border-left: 2px solid var(--color-overlay-strong);
  border-radius: 0.25rem;
  margin-top: 0.25rem;
  padding: 0.5rem 0;
}

.mobile-user-menu .dropdown-item {
  width: 100%;
  text-align: left;
}

@media (max-width: 991.98px) {
  .home-nav-item,
  .mobile-user-section {
    width: 100%;
  }

  .home-nav-item :deep(.nav-link) {
    display: flex;
    align-items: center;
    width: 100%;
    padding-left: 0;
    padding-right: 0;
  }

  .user-mobile-toggle {
    margin-top: 0 !important;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    text-align: left;
  }
}
</style>
